import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import lodash from 'lodash';
import Swal from "sweetalert2";
import { Button, Input, Modal, Table, Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

import { apiGetProduct, apiCreateBasket, apiGetProductBasket, apiUpdateBasket, apiFirstBasket, apiComfirm, apiPaid } from '../../services/api/store';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'antd/dist/antd.css';
import './style/detail.scss';

library.add(fas);

var lat;
var lng;

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    // return isJpgOrPng && isLt2M;
    return false;
}

const { TextArea } = Input;


const columns = [
    {
        title: 'ธนาคาร',
        dataIndex: 'bank',
        key: 'bank',
        //   render: text => <a>{text}</a>,
    },
    {
        title: 'เลขบัญชี',
        dataIndex: 'account',
        key: 'account',
    },
    {
        title: 'ชื่อบัญชี',
        dataIndex: 'name',
        key: 'name',
    },

];


const data = [
    {
        key: '1',
        bank: 'กสิกรไทย',
        account: '121-221-880-9',
        name: 'นายชนะ ใจสะอาด'
    }
];

class Detail extends Component {

    constructor(props) {
        super(props);

        this.state = {

            isModalVisible: false,
            isModalVisiblePay: false,
            loading: false,
            imageUrl: null,
            list_product: [],
            merchant_name: "",
            order_id: 0,
            bas_pro: [],
            data_bas: undefined,
            step: 0,
            group_pro: [],
            imgUp: null

        };
    }

    componentDidMount() {

        navigator.geolocation.getCurrentPosition(function (position) {
            lat = position.coords.latitude
            lng = position.coords.longitude

        });



        let url = window.location.href
        let lastIndex = url.substring(url.lastIndexOf('/') + 1)
        this.getProduct(lastIndex);
        // this.createBasket(lastIndex);
    }

    getProduct = async (id) => {
        let product = await apiGetProduct(id)
        if (product && product.status) {
            //   console.log(product)
            this.setState({
                list_product: product.data.result,
                merchant_name: product.data.merchant_name
            })


        }
    }

    createBasket = async (merchant_id, product) => {
        let basket = {
            "customer_id": parseInt(localStorage.getItem("cus_id")),
            "merchant_id": parseInt(merchant_id),
            "product_list": product
        }
        let create = await apiCreateBasket(basket)
        if (create && create.status) {

            // console.log(create)
            this.setState({
                order_id: create.data.order_id
            })

        }
    }

    updateBasket = async (pro) => {

        
        let basket = {
            "order_id" : this.state.order_id,
            "product_id" : pro.product_id,
            "amount" : pro.amount,
            "comment" : pro.comment
        }
        // console.log(basket)
        let update = await apiUpdateBasket(basket)
        if (update && update.status) {

            console.log(update)
            

        }
    }

    firstBasket = async (pro) => {

        
        let basket = {
            "order_id" : this.state.order_id,
            "product_id" : pro.product_id,
            "amount" : pro.amount,
            "comment" : pro.comment
        }
        // console.log(basket)
        let update = await apiFirstBasket(basket)
        if (update && update.status) {

            console.log(update)
            

        }
    }

    addBasket = (id) => {
        let url = window.location.href
        let lastIndex = url.substring(url.lastIndexOf('/') + 1)
        let idx = lodash.findIndex(this.state.group_pro, { product_id: id });
        if (this.state.step == 0) {
            
            this.setState({
                step: 1
            })

            if (idx < 0) {
                this.state.group_pro.push({
                    "product_id": id,
                    "comment": "",
                    "amount": 1
                })
                this.firstBasket({
                    "product_id": id,
                    "comment": "",
                    "amount": 1
                })
            } else {

                if("amount" in this.state.group_pro[idx]){
                    
                    this.state.group_pro[idx].amount += 1
                    this.firstBasket(this.state.group_pro[idx])

                    
                }else{
                    this.state.group_pro[idx].amount = 1
                    this.firstBasket(this.state.group_pro[idx])
                }
                
            }

            let basket = this.state.group_pro;
            
            
            this.createBasket(lastIndex, basket);

        } else {

            if (idx < 0) {
                this.state.group_pro.push({
                    "product_id": id,
                    "comment": "",
                    "amount": 1
                })

                let baskets = {
                    "product_id": id,
                    "comment": "",
                    "amount": 1
                };
                this.firstBasket(baskets)
            } else {

                if("amount" in this.state.group_pro[idx]){
                    
                    this.state.group_pro[idx].amount += 1

                    this.updateBasket(this.state.group_pro[idx]);
                }else{
                    this.state.group_pro[idx].amount = 1

                    this.updateBasket(this.state.group_pro[idx]);
                }
            }

            

                      

        }

    }


    confirmOrder = async () => {
        let id = this.state.order_id;
        let pro = await apiComfirm(id, lat, lng)
        if (pro && pro.status) {
            
            this.setState({
                isModalVisiblePay: true,
                isModalVisible: false
            })

        }
    }


    paidOrder = async () => {
        let id = this.state.order_id;
        var data = new FormData();
        data.append('order_id', id);
        data.append('image', this.state.imgUp);
        let pro = await apiPaid(data)
        if (pro && pro.status) {
            Swal.fire({
                title: 'Succcess!',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000
            })
            setTimeout(() => { window.location.href = "/"}, 1000)

        }else{
            Swal.fire({
                title: 'Error!',
                text: pro.message,
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            })
        }
    }

    productBasket = async () => {
        let id = this.state.order_id
        let pro = await apiGetProductBasket(id, lat, lng)
        if (pro && pro.status) {
            console.log(pro)
            this.setState({
                bas_pro: pro.data.result,
                data_bas: pro.data
            })

        }
    }

    onChange = (e, id) => {
        let idx = lodash.findIndex(this.state.group_pro, { product_id: id });
        if (idx < 0) {
            this.state.group_pro.push({
                "product_id": id,
                "comment": e.target.value,
            })
        } else {
            this.state.group_pro[idx].comment = e.target.value;
        }

    };


    pluspro = (id) => {
        let idx = lodash.findIndex(this.state.bas_pro, { product_id: id });
        console.log(this.state.bas_pro)
    }


    showModal = () => {
        this.setState({
            isModalVisible: true
        })
        this.productBasket();
    };

    handleOk = () => {
        this.setState({
            isModalVisible: false
        })
    };

    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    };

    showModalPay = () => {
        this.setState({
            isModalVisiblePay: true,
            isModalVisible: false
        })
    };

    handleOkPay = () => {
        this.setState({
            isModalVisiblePay: false
        })
    };

    handleCancelPay = () => {
        this.setState({
            isModalVisiblePay: false
        })
    };


    handleChangeImg = info => {
        const isLt2M = info.file.size / 1024 / 1024 < 2;

        if (
            isLt2M &&
            (info.file.type === "image/jpeg" ||
                info.file.type === "image/png" ||
                info.file.type === "image/jpg")
        ) {
            info.file.status = "done";
        } else {
            info.file.status = "error";
        }

        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }

        if (info.file.status === "done") {
            info.fileList.map((image) => {
                if (image.uid === info.file.uid) {
                    info.file.originFileObj = image.originFileObj;
                }
            });
            this.setState({
                LogoStation: info.file.originFileObj,
            });
            getBase64(info.file.originFileObj, (imageUrl) =>
                this.setState({
                    imageUrl,
                    imgUp: info.file.originFileObj,
                    loading: false,
                })
            );
        } else {
            this.setState({
                loading: false,
            });
        }
    };

    




    render() {


        const { loading, imageUrl } = this.state;
        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="hdtxt" style={{ marginTop: 8 }}>อัพโหลดหลักฐานการโอนเงิน</div>
                <p className="txt">อัพโหลดรูปหรือสลิปหลักฐานในการชำระเงิน</p>
            </div>
        );




        return (
            <div className="cover-promotion">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>


                <div className="box-detail container">
                    <div className="name-store">
                        <a href="/store" className="link-back">
                            <FontAwesomeIcon className="icon-back" icon={['fas', 'angle-left']} />
                        </a>
                        <h2 className="txt-store">{this.state.merchant_name ? this.state.merchant_name : ""}</h2>
                    </div>
                    <div className="list-menu">

                        <div className="btn-firm">
                            <Button className="btn-total" type="primary" onClick={() => { this.showModal() }}>
                                <img src="/img/icon/basket.png" alt="" className="img-fluid" />
                            </Button>
                        </div>
                        {/* <div className="row detail">
                            <div className="col-lg-1 col-mg-3 col-4 type-txt">
                                <p className="type-group">อาหารคาว</p>
                                <FontAwesomeIcon className="circle-txt" icon={['fas', 'circle']} />
                            </div>
                            <div className="col-lg-1 col-mg-3 col-4 type-txt">
                                <p className="type-group">3.4 กม.</p>
                                <FontAwesomeIcon className="circle-txt" icon={['fas', 'circle']} />
                            </div>
                            <div className="col-lg-1 col-mg-3 col-4">
                                <p className="type-group"><img src="/img/icon/delivery-man.png" alt="" className="img-fluid delivery" /> ฿15</p>
                            </div>
                        </div> */}
                        <hr className="brhd" />
                        <div className="select-menu">

                            <div className="row show-menu">
                                {
                                    this.state.list_product ? this.state.list_product.map((v, i) => {

                                        return <div key={i + 1} className="col-lg-6 col-md-6 col-12 col-show">
                                            <div className="row cover-menu">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <div className="img-menu">
                                                        <img src={v.product_image ? v.product_image : "/img/menu/p1.png"} alt="" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div className="bx-det">
                                                        <h5 className="name-menu">{v.product_name}</h5>
                                                        <div className="note">
                                                            <p className="special">คำแนะนำพิเศษ <span className="mini">(ไม่จำเป็นต้องระบุ)</span></p>
                                                            <TextArea rows={3} className="box-note" placeholder="หมายเหตุ" allowClear onChange={(e) => { this.onChange(e, v.product_id) }} />
                                                        </div>
                                                        <div className="count-bx">
                                                            <div className="num-order">
                                                                <p className="price">฿{v.product_price}</p>
                                                            </div>
                                                            <div className="btn-basket">
                                                                <Button onClick={() => { this.addBasket(v.product_id) }} className="app-menu">
                                                                    <div className="grid-btn">
                                                                        <img src="/img/icon/basket.png" alt="" className="img-fluid" />
                                                                        <p className="txt">ใส่ตระกร้า</p>
                                                                    </div>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }) : null
                                }





                            </div>

                        </div>
                    </div>

                    <Modal className="again" title="รายการสั่งซื้อสินค้า" visible={this.state.isModalVisible} onOk={this.handleOk} onCancel={this.handleCancel} footer={false}>
                        <div className="list-order">

                            {
                                this.state.bas_pro ? this.state.bas_pro.map((v, i) => {
                                    return <div key={i + 1} className="row menu">
                                        <div className="col-lg-3 col-md-4 col-12">
                                            <div className="img-menu">
                                                <img src={v.product_image ? v.product_image : ""} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="col-lg-9 col-md-8 col-12">
                                            <div className="name-order">
                                                <div className="grid-ta">
                                                    <p className="name">{v.product_name ? v.product_name : ""}</p>
                                                    <div className="count">
                                                        <div className="grid-count">
                                                            <div className="btn-plus">
                                                                <Button onClick={()=>{this.pluspro(v.product_name)}} className="btn-add">
                                                                    <FontAwesomeIcon className="plus-txt" icon={['fas', 'plus']} />
                                                                </Button>
                                                            </div>

                                                            <p className="num">{v.product_amount ? v.product_amount : ""}</p>

                                                            <div className="btn-minus">
                                                                <Button className="btn-re">
                                                                    <FontAwesomeIcon className="minus-txt" icon={['fas', 'minus']} />
                                                                </Button>
                                                            </div>

                                                            <div className="btn-del">
                                                                <Button className="btn-clear">
                                                                    <FontAwesomeIcon className="del-txt" icon={['fas', 'trash-alt']} />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid-ta">
                                                    <p className="name">ราคา</p>
                                                    <p className="baht">{v.product_price ? v.product_price : ""} บาท</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }) : null
                            }


                        </div>

                        <div className="con-price">
                            <div className="grid-ta">
                                <p className="name">รวมค่าสินค้า</p>
                                <p className="baht">{this.state.data_bas ? this.state.data_bas.total_price : 0} บาท</p>

                            </div>
                            <div className="grid-ta">
                                <p className="name">ค่าส่ง</p>
                                <p className="baht">{this.state.data_bas ? this.state.data_bas.shiping_price : 0} บาท</p>

                            </div>
                        </div>

                        <div className="total-price">
                            <div className="grid-ta">
                                <p className="name">รวมค่าสินค้า</p>
                                <p className="baht">{this.state.data_bas ? this.state.data_bas.grand_total : 0} บาท</p>

                            </div>

                        </div>
                        <div className="btn-pay">
                            <Button className="btn-total" type="primary" onClick={() => { this.confirmOrder() }}>
                                ยืนยันคำสั่งซื้อสินค้า
                                </Button>
                        </div>

                    </Modal>

                    <Modal className="payment" title="ชำระเงิน" visible={this.state.isModalVisiblePay} onOk={this.handleOkPay} onCancel={this.handleCancelPay} footer={false}>
                        <div className="table-bank">
                            <Table className="tabank" pagination={false} columns={columns} dataSource={data} />
                        </div>
                        <div className="row price-total">
                            <div className="col-lg-5">
                                <p className="txt">ยอดชำระทั้งหมด</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="txt">{this.state.data_bas ? this.state.data_bas.grand_total : 0}</p>
                            </div>
                            <div className="col-lg-3">
                                <p className="txt">บาท</p>
                            </div>
                        </div>

                        <div className="up-slip">
                            <Upload
                                accept="image/*"
                                name="avatar"
                                disabled={this.state.editable}
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                beforeUpload={beforeUpload}
                                onChange={this.handleChangeImg}
                            >
                                {/* {console.log(imageUrl)} */}
                                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </div>

                        <div className="cov-btnac">
                            <Button onClick={()=>{this.paidOrder()}} className="firm-btn">ยืนยันการชำระเงิน</Button>
                            <Button className="cancel-btn">ยกเลิก</Button>
                        </div>
                    </Modal>

                </div>
                <Footer />
            </div>
        )
    }
}

export default Detail;
